// fontawesome-config.js
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import * as solidIcons from '@fortawesome/free-solid-svg-icons';
import * as regularIcons from '@fortawesome/free-regular-svg-icons';
import * as brandIcons from '@fortawesome/free-brands-svg-icons';

// Solid Icons
const iconsSolid = [

    // Main
    solidIcons.faMagnifyingGlass,
    solidIcons.faPhone,
    solidIcons.faChevronUp,
    solidIcons.faChevronDown,
    solidIcons.faChevronLeft,
    solidIcons.faChevronRight,
    solidIcons.faXmark,
    solidIcons.faCheck,
    solidIcons.faBook,
    solidIcons.faUser,
    solidIcons.faBars,
    solidIcons.faCamera,
    solidIcons.faPlay,
    solidIcons.faStar,
    solidIcons.faSliders, 
    solidIcons.faRightFromBracket, 
    solidIcons.faAngleLeft,
    solidIcons.faAngleRight,
    solidIcons.faCircleInfo, 

    // Secondary
    solidIcons.faCheckCircle,
    solidIcons.faBath,
    solidIcons.faBus,
    solidIcons.faClock,
    solidIcons.faCommentDots,
    solidIcons.faCoffee,
    solidIcons.faConciergeBell,
    solidIcons.faBell,
    solidIcons.faCouch,
    solidIcons.faDumbbell,
    solidIcons.faFan,
    solidIcons.faGlassMartiniAlt,
    solidIcons.faHotel,
    solidIcons.faLeaf,
    solidIcons.faLock,
    solidIcons.faMapMarkerAlt,
    solidIcons.faMoneyBillAlt,
    solidIcons.faPaw,
    solidIcons.faPhoneSquareAlt,
    solidIcons.faShower,
    solidIcons.faSmokingBan,
    solidIcons.faSort,
    solidIcons.faStar,
    solidIcons.faSubway,
    solidIcons.faSun,
    solidIcons.faSwimmingPool,
    solidIcons.faTemperatureFull,
    solidIcons.faTShirt,
    solidIcons.faTv,
    solidIcons.faUtensils,
    solidIcons.faWheelchair,
    solidIcons.faWifi,
    solidIcons.faWind,
];

// Regular Icons
const iconsRegular = [
    regularIcons.faHeart,
];

// Brand Icons
const iconsBrand = [
    brandIcons.faFacebookF,
    brandIcons.faXTwitter,
    brandIcons.faYoutube,
    brandIcons.faInstagram
];


library.add(...iconsSolid, iconsRegular, iconsBrand);
dom.watch();

export { library }
// If you need to use the icon in your JS code, you can export it like this:
//export { faMagnifyingGlass };